import { InformeHorasPorProyecto } from "../../../../../infraestructure/persistence/rest/InformesAdapter"

export const BARSCHARTS = [
    {dataKey:'nHorasControl', fill:'#70AF52'},
    {dataKey:'nHorasUtilidad',fill:'#E09A05'},
    {dataKey:'nHorasTotal',fill:'#855AFF'}
]

export const DataMap = (data:InformeHorasPorProyecto[]) =>{
    return data.map((d:InformeHorasPorProyecto)=> d.proyecto===null ? {...d,...{proyecto:'Sin Proyecto'}} : d)
}